import { useRef } from 'react';
export const useModalRefs = () => {
  const modalRef = useRef(null);
  const overlayRef = useRef(null);
  const nodeRef = useRef(null);
  return {
    modalRef,
    overlayRef,
    nodeRef
  };
};